import axios from "axios";

class Api {
  setDefaults() {
    axios.defaults.baseURL = "https://dashboardapi.pipeup.ir";
    // axios.defaults.baseURL = "http://localhost:4021";
  }
}

const api = new Api();

export { api };
